import { render, staticRenderFns } from "./AHead.vue?vue&type=template&id=0c2aa23a&scoped=true&"
import script from "./AHead.vue?vue&type=script&lang=js&"
export * from "./AHead.vue?vue&type=script&lang=js&"
import style0 from "./AHead.vue?vue&type=style&index=0&id=0c2aa23a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2aa23a",
  null
  
)

export default component.exports